import { getOddleEatsBanner } from 'src/services/graphcms'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { NextPageContext } from 'next'

export const fetchOddleEatsBanner = createAsyncThunk(
  '@graphcms/banner',
  async ({
    countryCode,
    req
  }: {
    countryCode: string
    req: NextPageContext['req'] & {
      appVersion: string
      cartName: string
    }
  }) => {
    const result = await getOddleEatsBanner(countryCode)
    return result.data
  }
)
